import i18n from 'i18next'
import LanguageDetector from 'i18next-browser-languagedetector'
import { I18nextProvider } from 'react-i18next'
import mapCodeToFile from './mappers/mapCodeToFile'

i18n.use(LanguageDetector)
i18n.init({
  debug: false, // === ['production', 'test'].includes(process.env.NODE_ENV),
  defaultNS: 'translations',
  fallbackLng: 'en',
  ns: ['translations'],
  react: {
    wait: true,
  },
  resources: {},
})

async function ensure(code: string) {
  try {
    let resources = await mapCodeToFile(code)
    let base = code
    if (!resources && code.indexOf('-') !== -1) {
      base = code.split('-')[0]
      resources = await mapCodeToFile(base)
    }
    if (!resources) {
      return
    }

    i18n.addResourceBundle(code, 'translations', resources, true, false)
    if (base !== code) {
      i18n.addResourceBundle(base, 'translations', resources, true, false)
    }
  } catch (error) {
    console.error(error)
  }
}

const codes = ['en']
if (i18n.language && i18n.language !== 'en') {
  codes.push(i18n.language)
}

export const i18nReady: Promise<void> = Promise.all(
  codes.map(code => ensure(code)),
).then(() => undefined)

export default i18n
export { I18nextProvider }
